<template>
  <transition name="slide-fade">
    <div v-if="selectedJobId">
      <AlarmItemSkeleton v-if="!isLoaded" />

      <div v-else>
        <div class="p-grid alarm-header">
          <div class="p-col-fixed alarm-header-icon">
            <Button
                :style="{
                fontSize: '2rem',
                backgroundColor: selectedAlarm?.icon?.color || '#989898',
                borderColor: selectedAlarm?.icon?.color || '#989898',
                padding: '.7rem',
                borderRadius: '5px'
              }"
                v-tooltip.bottom="selectedAlarm.name ?? selectedAlarm.alarmName"
                class="mr-2"
            >
              <i :class="selectedAlarm?.icon?.name || 'mdi mdi-alert-outline'" />
            </Button>
          </div>
          <div class="p-col alarm-header-title">
            <h4 class="alarm-title">
              <strong>{{ selectedAlarm.name ?? selectedAlarm.alarmName }}</strong>
            </h4>
          </div>
        </div>
        <TabView v-model:activeIndex="activeTab" @tab-click="getHistoryAlarm()">
          <TabPanel :header="_t('menu.general')">
            <div class="p-grid">
              <div class="p-col-3 info-col">
                <p class="p-p-1 p-m-0 truncate-text">{{ _t('label_alarm_id') }}</p>
                <p class="p-p-1 p-m-0 truncate-text">{{ _t('label_system_id') }}</p>
                <p v-if="selectedAlarm.mediaProcessingType" class="p-p-1 p-m-0 truncate-text">
                  {{ _t('Alarm_Processing_Configuration') }}
                </p>
                <p class="p-p-1 p-m-0 truncate-text">{{ _t('label_status') }}</p>
                <p class="p-p-1 p-m-0 truncate-text">{{ _t('label_organization') }}</p>
              </div>
              <div class="p-col-5 info-col">
                <Button class="p-button-link p-button-sm p-p-1 p-m-0" @click="toAlarmPoint(selectedAlarm.alarmId, selectedAlarm.alarmPointId)">
                  <strong>
                    {{ selectedAlarm.alarmPointId }}
                  </strong>
                </Button>
                <p class="p-p-1 p-m-0 truncate-text">
                  <strong>
                    {{ selectedAlarm.systemId !== '[DEFAULT_EMPTY_SYS_ID_VALUE]' ? selectedAlarm.systemId : '' }}
                    {{
                      selectedAlarm.alarmSystemId !== '[DEFAULT_EMPTY_SYS_ID_VALUE]' ? selectedAlarm.alarmSystemId : ''
                    }}&nbsp;
                  </strong>
                </p>
                <p v-if="selectedAlarm.mediaProcessingType" class="p-p-1 p-m-0 truncate-text">
                  <strong>{{ selectedAlarm.mediaProcessingType }}&nbsp;</strong>
                </p>
                <p class="p-p-1 p-m-0 truncate-text">
                  <Badge v-if="selectedAlarm.alarmJobStatus"
                         :style="'background-color:' + associateColor(selectedAlarm.jobStatusColor)"/>
                  <span
                      v-if="selectedAlarm.alarmJobStatus"
                      :style="'color:' + associateColor(selectedAlarm.jobStatusColor)"
                      class="p-m-2"
                  >
                    <strong>
                      {{ _t(selectedAlarm.alarmJobStatus) }}&nbsp;
                    </strong>
                  </span>
                  <Badge
                      v-if="selectedAlarm.alarmPointStatus"
                      :style="'background-color:' + associateColor()"
                  />
                  <span
                      v-if="selectedAlarm.alarmPointStatus"
                      :style="'color:' + associateColor()"
                      class="p-m-1"
                  >
                    <strong>
                      {{ _t(selectedAlarm.alarmPointStatus) }}&nbsp;
                    </strong>
                  </span>
                </p>
                <p class="p-p-1 p-m-0 truncate-text">
                  <OrganizationLink ref="orgLink" v-model="selectedAlarmPoint" modelType="ALARMPOINT"/>
                </p>
              </div>
              <div class="p-col-4 info-col-right">
                <p class="p-p-1 p-m-0 truncate-text info-text">
                  <strong>{{ _t('label_message_priority') }}: {{
                      selectedAlarm.priority ? selectedAlarm.priority : ''
                    }}</strong>
                </p>
                <p class="p-p-1 p-m-0 truncate-text info-text">
                  <strong>{{ selectedAlarm.triggeredBy ? selectedAlarm.triggeredBy.login : '' }}</strong>
                </p>
                <p class="p-p-1 p-m-0 info-text">
                  <i class="mdi mdi-play-outline info-icon"></i>
                  {{ selectedAlarm.startDate }}
                </p>
                <p class="p-p-1 p-m-0 info-text">
                  <i class="mdi mdi-stop-circle-outline info-icon"/>
                  {{ selectedAlarm.doneDate }}
                </p>
                <p class="p-p-1 p-m-0 info-text">
                  <i :class="selectedAlarm.endDate ? 'mdi mdi-bookmark-outline' : 'mdi mdi-bookmark'"
                     :style="{ color: selectedAlarm.endDate ? 'black' : 'red' }"
                     class="info-icon"></i>
                  {{ selectedAlarm.endDate }}
                </p>
              </div>
            </div>
            <div class="alarm-text-section">
              <p class="section-label">{{ _t('label_alarm_text') }}</p>
              <Textarea v-model="selectedAlarm.text" :autoResize="true" rows="5" class="full-width"/>
            </div>
            <div>
              <hr>
              <span class="p-buttonset">
              <Button
                  :disabled="
                    !selectedAlarm.canBeReTriggered
                    && selectedAlarm.alarmPointStatus !== 'IDLE'
                    ||
                      !(
                          authorities.includes('SEND_WEB_ALARM')
                          || (authorities.includes('TRIGGER_AUTOGOING_ALARM') && selectedAlarmPoint.alarmPointId[0] === '$')
                      )"
                  class="btn-trigger"
                  @click="hasTriggerProps ? $emit('onTrigger') : prepareTriggerAgain('K'); triggerModalStatus = 'trigger';"
              >
                {{ _t('label_coming') }}
              </Button>
              <Button
                  :disabled="
                      selectedAlarm.endDate !== null
                      ||
                      !(
                          authorities.includes('SEND_WEB_ALARM')
                          || (authorities.includes('TRIGGER_AUTOGOING_ALARM') && selectedAlarmPoint.alarmPointId[0] === '$')
                      )
                  "
                  class="btn-going"
                  @click="prepareTriggerAgain('G'); triggerModalStatus = 'end';"
              >
                {{ _t('label_going') }}
              </Button>
              <Button
                  v-if="Number(alarmType) === 0"
                  :disabled="
                    !selectedAlarm.quitable
                    ||
                      !(
                          authorities.includes('SEND_WEB_ALARM')
                          || (authorities.includes('TRIGGER_AUTOGOING_ALARM') && selectedAlarmPoint.alarmPointId[0] === '$')
                      )
                  "
                  class="p-button-warning btn-terminate"
                  @click="terminateAlarm(selectedAlarm.alarmId)"
              >
                {{ _t('label_Terminate') }}
              </Button>
            </span>
            </div>
            <div v-if="selectedAlarm.instructionFiles">
              <hr>
              <span v-for="instructionFile in selectedAlarm.instructionFiles" :key="instructionFile">
                <Button
                    :disabled="instructionFile.includes(expiredFilePrefix) || instructionFile.includes(expiredFilePrefix.toLowerCase())"
                    :label="getFileLabel(instructionFile)"
                    class="p-button-link p-button-text p-button-success"
                    @click="openFile(instructionFile)"
                />
              </span>
            </div>
            <div v-if="selectedAlarm.participantStatusesSummary">
              <hr>
              <p class="section-label">{{ _t('label_Acknowledgements_detail') }}</p>
              <div v-for="item in selectedAlarm.participantStatusesSummary" :key="item.status">
                <p>
                  <Badge
                      :style="{
                    'background-color': associateColor(item.color),
                    color: associateColor(item.color) === 'transparent' ? 'gray' : 'white'
                  }"
                      :value="item.count"
                      style="border: 1px solid gray; border-radius: 10px"
                  />
                  {{ _t('label_participants') }} {{ _t(item.status) }}
                  <span style="float:right;">{{ _t('label_media_usage_manual') }}:
                  <SelectedOption v-model="selectedAlarmPoint.mediaUsageType"
                                  :options="mediaUsageTypes"
                                  optionLabel="label"
                                  optionValue="value"/>
              </span>
                </p>
              </div>
            </div>
            <div v-if="selectedCallGroupJobs.length > 0">
              <hr>
              <div class="participants-header">
                <p class="section-label">{{ _t('label_participants') }}</p>
                <Button
                    :label="expandParticipantsLabel"
                    class="p-button-success"
                    @click="expandAllParticipants"
                />
              </div>
              <div class="treetable-wrapper">
                <TreeTable :value="selectedCallGroupJobs"
                           :expandedKeys="expandedKeys"
                           @toggle="expandedKeys = $event.value"
                           class="treetable-table"
                >
                  <Column headerStyle="width: 2rem; text-align: center;" bodyStyle="text-align: center; vertical-align: middle;">
                    <template #body="slotProps">
                      <Checkbox :binary="true"
                                :modelValue="!!selectedCallGroupJobKeys[slotProps.node.key]"
                                @update:modelValue="toggleNodeSelection(slotProps.node.key, $event)"
                      />
                    </template>
                  </Column>
                  <Column :expander="true" headerStyle="width: 2rem; text-align: center;" bodyStyle="text-align: center; vertical-align: middle;"></Column>
                  <Column :header="_t('label_object_name')" field="name" style="width: 8rem;"></Column>
                  <Column :header="_t('label_started')" field="startDate" headerStyle="width: 5rem;"></Column>
                  <Column :header="_t('label_ends')" field="endDate" headerStyle="width: 5rem;"></Column>
                  <Column :header="_t('label_status')" field="status" style="width: 7rem;">
                    <template #body="slotProps">
                      <Badge
                          v-if="slotProps.node.data.status"
                          v-tooltip="_t(slotProps.node.data.status)"
                          :style="'margin:2px; width:100%; background-color: ' + associateColor(slotProps.node.data.color)"
                          :value="_t(slotProps.node.data.status)"
                          class="p-text-truncate"
                          style="font-size: 0.75rem !important;"/>
                    </template>
                  </Column>
                  <Column :header="_t('label_result')" field="result" style="width: 5rem;">
                    <template #body="slotProps">
                      <p v-tooltip.bottom="_t(slotProps.node.data.result ? '_'+slotProps.node.data.result : '')"
                         class="p-text-truncate cell-no-margin">
                        {{ _t(slotProps.node.data.result ? '_' + slotProps.node.data.result : '') }}
                      </p>
                    </template>
                  </Column>
                  <Column :header="_t('label_call_number')" field="callingNumber" style="width: 5rem;">
                    <template #body="slotProps">
                      <p v-tooltip.left="slotProps.node.data.callingNumber" class="p-text-truncate cell-no-margin">
                        {{ slotProps.node.data.callingNumber }}</p>
                    </template>
                  </Column>
                </TreeTable>
              </div>
            </div>
          </TabPanel>
          <TabPanel :header="_t('label_info')">
            <p>{{ _t('label_number_of_repeats') }}: {{ selectedAlarmPoint.countRepeat }}</p>
            <p>{{ _t('label_between_repeats') }}: {{ selectedAlarmPoint.repeatBetween }}</p>
            <p>{{ _t('label.Description') }}</p>
            <Textarea v-model="selectedAlarm.description" :autoResize="true" rows="5" class="full-width"/>

            <p>{{ _t('label_comment') }}</p>
            <Textarea v-model="selectedAlarm.alarmJobComment" :autoResize="true" rows="5" class="full-width"/>
          </TabPanel>
          <TabPanel :header="_t('INSTRUCTION_FILES')">
            <div v-if="selectedAlarmPoint.instructionFiles && selectedAlarmPoint.instructionFiles.length > 0"
                 class="p-grid p-nogutter p-mb-4">
              <div v-for="(instruction, index) in selectedAlarmPoint.instructionFiles"
                   :key="index"
                   class="p-col-12"
              >
                <Button
                    :disabled="instruction.includes(expiredFilePrefix) || instruction.includes(expiredFilePrefix.toLowerCase())"
                    :label="getFileLabel(instruction)"
                    class="p-button-link p-button-text p-button-success"
                    @click="openFile(instruction)"
                />
              </div>

              <FileViewer
                  v-for="viewer in fileViewers"
                  :key="viewer.id"
                  :ref="viewer.ref"
                  :file="viewer.file"
                  @close="removeViewer(viewer.id)"
              />
            </div>
            <p v-else>
              <b>
                {{ _t('label_intruction_file_missed') }}
              </b>
            </p>
          </TabPanel>
          <TabPanel :header="_t('label_history')">
            <HistoryTab
                :items="history.items"
                :loading="history.loading"
                @select-table-page="historyTab.currentPage = $event"
            ></HistoryTab>
          </TabPanel>
        </TabView>
      </div>
    </div>
  </transition>

  <div>
    <AlarmModal :isOpen="triggerAgainDlg"
                :data="preparedTriggerBody"
                :isAlarmPanel="false"
                :triggerModalStatus="triggerModalStatus"
                :originalAlarmDialogText="preparedTriggerBody.button.text"
                :alarmDialogTextArray="computedTriggerBodyDialogTextArray"
                :replacedAlarmDialogText="computedTriggerBodyDialogCustomText"
                @replaceAlarmDialogText="(text) => computedTriggerBodyDialogCustomText = text"
                @onClose="triggerAgainDlg = false; preparedTriggerBody.button.text = ''"
                @onSubmit="triggerAgain"/>
  </div>
</template>

<script>

import {getAlarm, getHistoryByAlarm, getHistoryDetails, prepareTriggerAgainAlarm, terminateAlarm, triggerAgainAlarm} from '@/api/alarmTable'
import {getAlarmPoint} from '@/api/alarmPoint'
import {associateColor} from '@/service/helper/styleHelper'
import OrganizationLink from '@/components/ixarma/OrganizationLink'
import AlarmModal from '@/components/AlarmModal.vue'
import FileViewer from '@/components/FileViewer.vue'
import HistoryTab from '@/views/alarm_table/history-tab'
import AlarmItemSkeleton from './AlarmItemSkeleton.vue'
import Tooltip from 'primevue/tooltip'
import {getStoredUser} from '@/storage/authStorage'
import { normalizeAlarmPointIcon } from '@/views/alarm_point/utils/alarmPointDto'
import { ALL_HISTORY_HOURS } from '@/constants/durationFilters'

export default {
  name: "item",
  components: {
    AlarmItemSkeleton,
    HistoryTab,
    OrganizationLink,
    AlarmModal,
    FileViewer,
  },
  directives: {
    'tooltip': Tooltip
  },
  emits: ['onTrigger'],
  props: {
    selectedJobId: {
      type: [String, null],
      default() {
        return null
      }
    },
    alarmType: {
      type: [Number, String],
      default() {
        return 0
      }
    },
    hasTriggerProps: {
      type: Boolean,
      default: true
    },
    fixBrokenJobId: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectedAlarm: {
        alarmPointName: '',
        alarmJobEndDate: '',
        participantStatusesSummary: null,
        jobStatusColor: '',
        callGroupJobs: []
      },
      selectedCallGroupJobs: [],
      selectedCallGroupJobKeys: [],
      selectedAlarmPoint: {
        mediaUsageType: 'ALL'
      },
      triggerAgainDlg: false,
      preparedTriggerBody: {
        button: {}
      },
      computedTriggerBodyDialogTextArray: [],
      computedTriggerBodyDialogCustomText: '',
      selectedAlarmIntervalId: null,
      activeTab: 0,
      history: {
        items: [],
        totalItems: 0,
        pagesCount: 0,
        loading: false,
      },
      historyTab: {
        currentPage: 0,
        sortField: '',
        textFilter: '',
        pageSize: parseInt(localStorage.getItem('alarmTableRows') ?? 10),
        columnsFilter: `alarmPointId=`,
        organiztionFilter: null,
      },
      isLoaded: false,
      expiredFilePrefix: 'EXPIRED',
      expandedKeys: {},
      triggerModalStatus: 'trigger',
      authorities: getStoredUser()?.authorities ?? [],
      fileViewers: [],
      viewerCounter: 0,
    }
  },
  mounted() {
    this.activeTab = 0;
    if (this.selectedJobId !== null) {
      this.runGetAlarm()
    }
  },
  watch: {
    selectedJobId(value) {
      if (value !== null) {
        this.activeTab = 0;
        this.isLoaded = false
        this.runGetAlarm()
      }

      this.fileViewers = [];
    },
  },
  beforeUnmount() {
    this.stopGetAlarm()
  },
  methods: {
    openFile(file) {
      const id = this.viewerCounter++;
      this.fileViewers.push({
        id,
        ref: `fileViewer_${id}`,
        file
      });
    },
    getFileLabel(file) {
      const extension = file.split('.').pop().toLowerCase();
      let postfix = '';

      if (extension === 'mp4') {
        postfix = ' Video'
      }
      return file.split('/').pop().replace(/\.[^.]*$/, '').replace('_received', '') + postfix
    },
    removeViewer(id) {
      const index = this.fileViewers.findIndex(v => v.id === id);
      if (index !== -1) {
        this.fileViewers.splice(index, 1);
      }
    },
    toggleNodeSelection(key, checked) {
      if (checked) {
        this.selectedCallGroupJobKeys = { ...this.selectedCallGroupJobKeys, [key]: true }
      } else {
        const keys = { ...this.selectedCallGroupJobKeys }
        delete keys[key]
        this.selectedCallGroupJobKeys = keys
      }
    },
    collectAllKeys(nodes) {
      let keys = {};
      nodes.forEach(node => {
        if (node.key !== undefined) {
          keys[node.key] = true;
        }

        if (node.children && node.children.length > 0) {
          Object.assign(keys, this.collectAllKeys(node.children));
        }
      });

      return keys;
    },
    expandAllParticipants() {
      if (Object.keys(this.expandedKeys).length > 0) {
        this.expandedKeys = {}
      } else {
        this.expandedKeys = this.collectAllKeys(this.selectedCallGroupJobs);
      }
    },
    toAlarmPoint(id, alarmPointId = null) {
      let route = this.selectedAlarmPoint.deleted ? '/deleted-alarm-points/' : '/alarm-points/'
      this.$router.push({
        path: `${route}${id}`,
        query: alarmPointId ? { alarm_point_filter: alarmPointId } : {}
      })
    },
    runGetAlarm() {
      this.processGetAlarm()
      if (!this.selectedAlarmIntervalId) {
        this.selectedAlarmIntervalId = setInterval(() => {
          this.processGetAlarm()
        }, 5000)
      }
    },
    stopGetAlarm() {
      clearInterval(parseInt(this.selectedAlarmIntervalId))
    },
    processGetAlarm() {
      if (this.selectedJobId) {
        if (this.alarmType === 0) {
          getAlarm(this.fixBrokenJobId === true ? Number(this.selectedJobId) + 1 : this.selectedJobId).then((response) => {
            if (response.data) {
              this.selectedAlarm = response.data
              this.prettifyAlarmAttributes()
              if (this.selectedAlarm.callGroupJobs) {
                this.selectedCallGroupJobs = []
                this.mapCallGroupJobs()
              }
              getAlarmPoint(response.data.alarmId).then((response) => {
                this.selectedAlarmPoint = response.data
              });
              this.isLoaded = true
            }

          })
        } else {
          getHistoryDetails(this.selectedJobId).then((response) => {
            if (response.data) {
              this.selectedAlarm = response.data
              this.prettifyAlarmAttributes()
              getAlarmPoint(this.selectedAlarm.alarmId).then((response) => {
                this.selectedAlarmPoint = response.data
              });
              if (this.selectedAlarm.callGroupJobs) {
                this.selectedCallGroupJobs = []
                this.mapCallGroupJobs()
                this.isLoaded = true
              }
            } else {
              this.$emit('update:selectedJobId', null);
            }
          })
        }
      } else {
        this.isLoaded = false
        this.selectedAlarm = {
          alarmPointName: '',
          alarmJobEndDate: '',
          participantStatusesSummary: null,
          jobStatusColor: '',
          callGroupJobs: []
        };
      }
    },
    prettifyAlarmAttributes() {
      if (this.selectedAlarm) {
        if (!this.selectedAlarm.icon) {
          this.selectedAlarm.icon =  { color: "#989898", icon: "", name: "mdi mdi-alert-outline" }
        }
        this.selectedAlarm.alarmJobComment = this._t(this.selectedAlarm.alarmJobComment)
        this.selectedAlarm.description = this._t(this.selectedAlarm.description)
        this.selectedAlarm.icon = normalizeAlarmPointIcon(this.selectedAlarm.icon)
      }
    },
    prepareTriggerAgain(status = null) {
      let type = 'history'
      if (this.alarmType === 0) {
        type = 'alarmtable'
      }

      if (!this.selectedAlarm.icon) {
        this.selectedAlarm.icon =  { color: "#989898", icon: "", name: "mdi mdi-alert-outline" }
      }
      prepareTriggerAgainAlarm(this.selectedJobId, type).then((response) => {
        this.preparedTriggerBody = response.data
        this.preparedTriggerBody.button = {
          bgColor: this.selectedAlarm.icon.color,
          alarmName: this.selectedAlarm.name,
          icon: this.selectedAlarm.icon,
        }

        this.preparedTriggerBody.priority = this.selectedAlarm.priority
        this.computedTriggerBodyDialogTextArray = response.data.text.split('<original>')
        this.triggerAgainDlg = true
        if (status !== null) {
          this.preparedTriggerBody.eventType = status
        }
      })
    },
    triggerAgain() {
      if (this.computedTriggerBodyDialogCustomText.length > 0 && this.computedTriggerBodyDialogTextArray.length > 0) {
        this.preparedTriggerBody.text = this.computedTriggerBodyDialogCustomText
      }
      triggerAgainAlarm(this.preparedTriggerBody).then(() => {
        if (this.selectedAlarm.endDate) {
          this.$emit('update:selectedJobId', null);
        }
        this.triggerAgainDlg = false
        this.$emit('clearComponent')
      });
    },
    terminateAlarm(alarmId) {
      terminateAlarm(alarmId).then(() => {
        this.processGetAlarm()
      })
    },
    mapCallGroupJobs() {
      this.selectedAlarm.callGroupJobs.forEach((item, index) => {
        const container = {data: {}, children: []};
        container.data = item
        container.leaf = false
        container.key = index;
        container.data.id = 'Call Group: ' + container.data.id
        for (const participant of container.data.participantJobs) {
          const mediaJobs = []
          for (const mediaJob of participant.configuredMediaJobs) {
            const mediaJobData = {
              key: mediaJob.id,
              data: {
                id: 'Media Job: ' + mediaJob.id,
                name: mediaJob.callingDeviceType,
                startDate: mediaJob.startDate,
                endDate: mediaJob.endDate,
                status: mediaJob.configuredMediaJobStatus,
                message: mediaJob.message,
                result: mediaJob.result,
                color: mediaJob.statusColor ?? null,
                callingNumber: mediaJob.callingNumber,
              }
            }
            mediaJobs.push(mediaJobData)
          }
          const participantData = {
            key: participant.id,
            data: {
              id: 'Participant: ' + participant.id,
              name: participant.name + ' ' + participant.surname,
              status: participant.participantJobStatus,
              color: participant.jobStatusColor ?? null,
            },
            children: mediaJobs
          }
          if (!(this.selectedAlarm.callGroupJobs.length === 1 && container.data.name === null)) {
            container.children.push(participantData)
          } else {
            this.selectedCallGroupJobs.push(participantData)
          }
        }
        if (!(this.selectedAlarm.callGroupJobs.length === 1 && container.data.name === null)) {
          this.selectedCallGroupJobs.push(container)
        }
      })
    },
    associateColor,
    getHistoryAlarm() {
      if (this.activeTab === 3) {
        this.historyTab.columnsFilter = {
          alarmPointId: this.selectedAlarm.alarmPointId,
        }
        this.history.loading = true
        getHistoryByAlarm(
            this.selectedAlarm.alarmId,
            this.historyTab.currentPage,
            this.historyTab.sortField,
            this.historyTab.textFilter,
            this.historyTab.pageSize,
            this.historyTab.columnsFilter,
            this.historyTab.organiztionFilter,
            {
              hours: ALL_HISTORY_HOURS,
              option: 'HOURS_DURATION'
            },
        ).then(response => {
          this.history.items = response.data.list ?? [];
          this.history.totalItems = response.data.count;
          this.history.pagesCount = response.data.pagesCount;
        })
            .finally(() => {
              this.history.loading = false;
            })
      }
    }
  },
  computed: {
    mediaUsageTypes() {
      return [
        {value: 'ALL', label: this._t('label_as_configured')},
        {value: 'VOICE', label: this._t('label_voice_only')},
        {value: 'TEXT', label: this._t('label_text_only')},
      ]
    },
    expandParticipantsLabel() {
      return Object.keys(this.expandedKeys).length > 0 ? this._t('label_collapse_all') : this._t('label_expand_all')
    }
  }
}
</script>

<style scoped src="./alarm-item.css" />
